var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKy = function SvgKy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.969 12H12v-.032l-.032.032ZM12 6.26V0h-.002C5.371 0 0 5.373 0 12h6.26V8.474l3.526 3.525h2.182l.032-.032V9.786L8.474 6.26H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M17.217 8.87a2.087 2.087 0 1 0 0-4.175 2.087 2.087 0 0 0 0 4.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.07 1.565a12.057 12.057 0 0 0-4.506 4.506v5.93h3.13V4.695H12v-3.13H6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M11.999 10.524 7.735 6.26H6.26L11.999 12v-1.476ZM20.869 6.26h-7.304v3.131h7.304v-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M13.565 14.087v2.087h1.098a3.638 3.638 0 0 0 2.555 1.043c.994 0 1.895-.398 2.554-1.043h1.098v-2.087h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M13.565 8.869v3.13c0 2.796 3.653 3.653 3.653 3.653S20.87 14.795 20.87 12V8.868h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M17.217 10.54c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835v1.461c.913 0 .913.835 1.826.835s.913-.835 1.826-.835.913.835 1.827.835c.913 0 .913-.835 1.826-.835v-1.46c-.913 0-.913.834-1.826.834-.914 0-.914-.835-1.827-.835ZM17.217 7.617c-.913 0-.913.834-1.826.834s-.913-.834-1.826-.834v1.46c.913 0 .913.835 1.826.835s.913-.834 1.826-.834.913.834 1.827.834c.913 0 .913-.834 1.826-.834V7.617c-.913 0-.913.834-1.826.834-.914 0-.914-.834-1.827-.834Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKy;